<template>
  <div class="articleContent">
    <bread :data="breadData"/>
    <div class="articleContent-content-header center-wrapper">
      <div class="articleContent-header-left">
        <h1 class="articleContent-content-left-title">
          {{dataList.title}}
        </h1>
        <p class="articleContent-content-left-titleAbout">
          <span>{{dataList.create_time}}</span>
          <span style="margin-left: 25px">文章来源：{{dataList.source}}</span>
        </p>
      </div>
    </div>
    <div class="articleContent-content center-wrapper" >
      <div class="articleContent-content-left">
        <ul class="articleContent-content-left-jianjie"  v-html="dataList.content">
        </ul>
        <div class="left-jianjie-img-fgx">
        </div>
        <div class="left-jianjie-cnxk">
          <p class="left-jianjie-cnxk-title">猜你想看</p>
          <div class="left-jianjie-cnxk-content">
            <div class="left-jianjie-cnxk-content-cz" @click="cnxkClick(1)">
              <img src="@/assets/img/contentJiantou.svg" alt="">
            </div>
            <div class="left-jianjie-cnxk-contents">
              <ul class="left-jianjie-cnxk-contents-flex">
                <li class="left-jianjie-cnxk-contents-item" @click="newsDetail(item)" v-for="(item, index) of newsList" :key='index'>
                  <img :src="item.img_url" alt="" width="100%">
                  <p style="font-size: 16px;
                      font-weight: 400;
                      line-height: 22px;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      display: -webkit-box;
                      -webkit-line-clamp: 3;
                      -webkit-box-orient: vertical;"
                     v-html="item.content"
                  ></p>
                </li>
              </ul>
            </div>
            <div class="left-jianjie-cnxk-content-cz" @click="cnxkClick(-1)">
              <img src="@/assets/img/contentJiantou.svg" style="transform: rotateZ(180deg);" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="articleContent-content-right">
        <div class="articleContent-right-content">
          <div class="articleContent-right-content-title">
            <img src="@/assets/img/rdzjImg.png" alt="">
            <span>
              热点资讯
            </span>
          </div>
          <ul class="articleContent-right-content-list">
            <li class="articleContent-list-item" v-for="(item, index) of rdzxList[active]" @click="newsDetail(item)" :key="index" v-html="item.title"></li>
          </ul>
          <div class="articleContent-right-bottom"  @click="changeMore">
            <img src="@/assets/img/hyh.svg" alt="">
            <span>
              换一换
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bread from '@/components/com-breadcrumb'
import {fetchNewsPmDetails, fetchNewspmList, news, newsList} from '@/api/api';
export default {
  components: {
    bread
  },
  created () {
    this.readList()
  },
  mounted () {
    let jsWidth = ()=>{
      let contItemList = [...document.getElementsByClassName('left-jianjie-cnxk-contents-item')]
      let cont = document.getElementsByClassName('left-jianjie-cnxk-contents')[0].offsetWidth / 100
      let czDom = document.getElementsByClassName('left-jianjie-cnxk-contents-flex')[0]
      let marNum = cont * 33.26
      czDom.style.width = marNum * contItemList.length + 'px'
      czDom.style.marginLeft = `${this.wyIndex * marNum}px`
      contItemList.forEach(item => {
        item.style.width = cont * 30 +'px'
      })
    }
    this.readListBottom(jsWidth)
    jsWidth()
    window.addEventListener('resize', jsWidth)
  },
  data () {
    return {
      dataList: {},
      wyIndex: 0,
      bottomItemWidth: 0,
      rdzxList: [
        {
          content: '卢浮宫西翼迎最年轻中国艺术家：令西方珠宝为...',
        },{
          content: '卢浮宫西翼迎最年轻中国艺术家：令西方珠宝为...',
        },{
          content: '卢浮宫西翼迎最年轻中国艺术家：令西方珠宝为...',
        },{
          content: '卢浮宫西翼迎最年轻中国艺术家：令西方珠宝为...',
        },{
          content: '卢浮宫西翼迎最年轻中国艺术家：令西方珠宝为...',
        },{
          content: '卢浮宫西翼迎最年轻中国艺术家：令西方珠宝为...',
        },
      ],
      // jianjieList: [
      //   {
      //     imgList: [
      //       require('@/assets/img/articleContent-1.svg'),
      //     ]
      //   },
      //   {
      //     content: `<div style='margin: 25px 0'>
      //     <span>钻石</span>
      //     （ Diamond ）是一种 r 元素矿物 J ( Elemental mineral ) ，纯净的钻石完全由碳元素（ C ）构成，素矿物。环境中，「钻石 J 形成于地球内部 130 一 ZOOkm 深的地慢（ Mant ! e ）层，温度必须达到 900 " C 至 1300 " C , 是唯一可以用作宝石的单一元压强达到 4 . 5 万至 6 万大气压的黑色碳才会转换为透明的晶体状态，亦即「钻石」。
      //     </div>
      //     <div style='margin-bottom: 25px'>在火山爆发等地壳活动中，地慢层中包含「钻石」的岩石有可能因地壳运动而粉碎，被爆发的岩浆喷出地表并瞬间冷却，于是就完整保留在地表层上。</div>`
      //   },{
      //     content: `<div style='margin: 25px 0'>
      //     <span>钻石</span>
      //     （ Diamond ）是一种 r 元素矿物 J ( Elemental mineral ) ，纯净的钻石完全由碳元素（ C ）构成，素矿物。环境中，「钻石 J 形成于地球内部 130 一 ZOOkm 深的地慢（ Mant ! e ）层，温度必须达到 900 " C 至 1300 " C , 是唯一可以用作宝石的单一元压强达到 4 . 5 万至 6 万大气压的黑色碳才会转换为透明的晶体状态，亦即「钻石」。
      //     </div>
      //     <div style='margin-bottom: 25px'>在火山爆发等地壳活动中，地慢层中包含「钻石」的岩石有可能因地壳运动而粉碎，被爆发的岩浆喷出地表并瞬间冷却，于是就完整保留在地表层上。</div>`
      //   },{
      //     content: `<p style='margin: 25px 0'>因此钻石往往开采自火山岩，如「金伯利岩」（ Kimberlite ）及「钾镁煌斑岩」（ LamProite ）这两种火山岩中。</p>`,
      //     imgList: [
      //       require('@/assets/img/jewelryEncycJianjieImagListItem-1.png'),
      //       require('@/assets/img/jewelryEncycJianjieImagListItem-1.png'),
      //       require('@/assets/img/jewelryEncycJianjieImagListItem-1.png')
      //     ]
      //   },{
      //     content: `<p style='margin-top: 25px'>因此钻石往往开采自火山岩，如「金伯利岩」（ Kimberlite ）及「钾镁煌斑岩」（ LamProite ）这两种火山岩中。</p>
      //     <p style='margin-top: 25px'>因此钻石往往开采自火山岩，如「金伯利岩」（ Kimberlite ）及「钾镁煌斑岩」（ LamProite ）这两种火山岩中。</p>
      //     <p style='margin: 25px 0'>因此钻石往往开采自火山岩，如「金伯利岩」（ Kimberlite ）及「钾镁煌斑岩」（ LamProite ）这两种火山岩中。</p>`
      //   },{
      //     content: `<p style='margin: 25px 0'>钻石的评级因素钻石的评级依据四个主要因素，亦即常说的 r4CJ。</p>
      //     <p>Carat （克拉重量）：宝石的重量。</p>
      //     <p>Cofor （颜色）：颜色的等级，相对的洁白度，或彩色的稀有性和美观性。</p>
      //     <p>Clarity （净度）：包裹体和裂隙的程度。</p>
      //     <p>Cut （切工）：切磨的啄型和品质。</p>`
      //   },
      // ],
      newsList: [],
      rdzxList: [],
      breadData: [
        {
          title: '甄宝阁',
          to: '/'
        },{
          title: '行业讯息',
           to: '/trade'
        },{
          title: '文章内容',
        }
      ],
      active: 0
    }
  },
  methods: {
    newsDetail (item) {
      document.body.scrollTop = 0; // firefox
      document.documentElement.scrollTop = 0; // safari
      window.pageYOffset = 0; // 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁
      this.$route.query.articleId = item.id
      this.readList()
    },
    changeMore () {
      this.active == this.rdzxList.length-1 ? (this.active = 0) : this.active++
    },
    readListBottom (callback=()=>{}) {
      newsList({per_page: 12, page: 1, sort: 'rand'}).then(r => {
        this.newsList = r.data.data.map(item => {
          item.content = item.content.replace(/&lt;/ig, '<').replace(/&gt;/ig, '>').replace(/&quot;/ig, '"').replace(/&amp;nbsp;/ig, ' ').replace(/<[^>]+>/g,"")
          return item
        })
        let i = 0
        this.rdzxList = this.newsList.reduce((arr, item, index) => {
          if (index%5 == 0) {
            if (index != 0) {
              i++
            }
            arr[i] = []
          }
          arr[i].push(item)
          return arr
        }, [])
        this.$nextTick(() => {
          callback()
        })
      })
    },
    readList () {
      news({id: this.$route.query.articleId}).then(res => {
        res.data.data.content = res.data.data.content.replace(/&lt;/ig, '<').replace(/&gt;/ig, '>').replace(/&quot;/ig, '"').replace(/&amp;nbsp;/ig, ' ')
        this.dataList = res.data.data
      })
    },
    cnxkClick (i) {
      let contItemList = [...document.getElementsByClassName('left-jianjie-cnxk-contents-item')]
      if ((i == 1 && this.wyIndex == 0) || (i == -1 && -this.wyIndex == (contItemList.length - 3))) return
      this.wyIndex +=i
      let cont = document.getElementsByClassName('left-jianjie-cnxk-contents')[0].offsetWidth / 100
      let marNum = cont * 33.26
      document.getElementsByClassName('left-jianjie-cnxk-contents-flex')[0].style.marginLeft = `${this.wyIndex * marNum}px`
    }
  }
}
</script>

<style lang='scss'>
.articleContent-content-header {
  .articleContent-header-left {
    width: 70%;
  }
  margin-top: 30px;
  .articleContent-content-left-title {
    color: rgba(26, 26, 26, 1);
    font-size: 24px;
    font-weight: 700;
  }
  .articleContent-content-left-titleAbout {
    font-size: 14px;
    font-weight: 400;
    color: rgba(166, 166, 166, 1);
    padding-bottom: 8px;
    margin-top: 30px;
    border-bottom: 1px dashed rgba(196, 196, 196, 1);
  }
}
.articleContent-content {
  display: flex;
  justify-content: space-between;
  .articleContent-content-left {
    width: 70%;
    .articleContent-content-left-jianjie {
      margin-top: 25px;
        line-height: 25px;
        color: rgba(114, 113, 113, 1);
        img {
          width: 100%
        }
        .right-jianjie-title {
          font-weight: 600;
          font-size: 20px;
        }
        .right-jianjie-img{
          margin: 10px 0;
          display: flex;
          justify-content: space-around;
          flex-wrap: wrap;
          .right-jianjie-img-item{
            width: 30%;
            margin-top: 10px;
          }
        }
      }
  }
  .left-jianjie-img-fgx {
    margin: 30px 0;
    border-bottom: 1px dashed rgba(196, 196, 196, 1);
    display: flex;
    justify-content: center;
  }
  .left-jianjie-img-fgx::after {
    content: '本文完';
    float: left;
    font-size: 14px;
    color: rgba(166, 166, 166, 1);
    text-align: center;
    display: inline-block;
    padding: 5px;
    background: rgb(247,247,247);
    transform: translateY(50%);
  }
  .left-jianjie-cnxk {
    padding-bottom: 30px;
    .left-jianjie-cnxk-title {
      font-size: 18px;
      color: rgba(26, 26, 26, 1);
      font-weight: 600;
    }
  }
  .left-jianjie-cnxk-content {
      display: flex;
    .left-jianjie-cnxk-content-cz {
      cursor: pointer;
      width: 8%;
      display: flex;
      justify-content: center;
      align-items: center;
      >img {
        width: 30px;
      }
    }
    .left-jianjie-cnxk-contents {
      width: 84%;
      overflow: hidden;
      .left-jianjie-cnxk-contents-flex {
        transition: all 0.5s;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .left-jianjie-cnxk-contents-item {
        cursor: pointer;
        background: #fff;
        border-radius: 10px;
        padding: 10px;
        color: rgba(26, 26, 26, 1);
        line-height: 25px;
        >img {
          height: 150px;
        }
      }
    }
  }
  .articleContent-content-right {
    width: 25%;
    .articleContent-right-content {
      border-radius: 5px;
      padding: 10px;
      background: #fff;
      .articleContent-right-content-list {
        .articleContent-list-item:last-child {
          margin-bottom: 0;
          border-bottom: none;
        }
        .articleContent-list-item:first-child {
        }
        .articleContent-list-item-active {
          color: rgba(26, 26, 26, 1);
        }
        .articleContent-list-item {
          cursor: pointer;
          color: rgba(114, 113, 113, 1);
          border-bottom: 1px solid rgba(240, 240, 240, 1);
          margin: 10px 0;
          line-height: 25px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;				//溢出内容隐藏
          text-overflow: ellipsis;		//文本溢出部分用省略号表示
          display: -webkit-box;			//特别显示模式
          -webkit-line-clamp: 2;			//行数
          line-clamp: 2;					
          -webkit-box-orient: vertical;	//盒子中内容竖直排列
        }
        .articleContent-list-item:hover {
          color: rgb(32, 147, 202);
        }
      }
    }
    .articleContent-right-content-title, .articleContent-right-bottom {
      cursor: pointer;
      color: rgba(32, 147, 202, 1);
      margin: 15px;
      display: flex;
      align-items: center;
      >span {
        margin-left: 10px;
      }
    }
    .articleContent-right-bottom {
      margin: 15px 0 12px;
      text-decoration-line: underline;
    }
  }
}
</style>